const STORAGE_KEY = "MRT_COLUMN_PREFERENCES";

/* ---------- READ ---------- */
export const getColumnPreference = (moduleKey, defaultValue = {}) => {
  try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
    return {
      ...defaultValue,
      ...(stored[moduleKey] || {}),
    };
  } catch {
    return defaultValue;
  }
};


/* ---------- WRITE ---------- */
export const saveColumnPreference = (moduleKey, columnVisibility) => {
  try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");

    stored[moduleKey] = columnVisibility;

    localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
  } catch {
    // silent fail
  }
};

/* ---------- RESET (OPTIONAL) ---------- */
export const resetColumnPreference = (moduleKey) => {
  try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
    delete stored[moduleKey];
    localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
  } catch {}
};
